/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */ 
/**
 * Component : JointTenancyCoOwnerAdd
 * Using for Add multiple co owner
 */
import React, { useEffect} from 'react';
import { Divider, Grid, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import { AUTH_STRINGS } from '../../../../../constants/strings';
import FxCard from '../../../../Container/FxCard';
import FxCardBody from '../../../../Container/FxCardBody';
import FxCardFooter from '../../../../Container/FxCardFooter';
import { FxTextEdit } from '../../../../Input/FxText/FxTextEdit';
import FxLabelView from '../../../../Input/FxLabel/FxLabelView';
import { FxButton } from '../../../../Action/FxButton';
import usa_state from '../../../../Utils/usa_states.json'
import { deleteUnwantedRequest, handleKeyDownChange, handleZipChange, handleAddressChange, setZipValidationOptions, setPhoneValidationOptions, convertToPhoneRequestFormat, setSsnValidationOptions, setEmailValidationOptions, setItinValidationOptions, ShowInfoToolTip, handleFieldChange, handleDateValidation, handleEmailChange, setCityValidation, fetchDataFromState, isNullOrUndefined } from '../../../../Utils/CommonBaseClass';
import { FxDateEdit } from '../../../../Input/FxDate/FxDateEdit';
import FxPhoneEdit from '../../../../Input/FxPhone/FxPhoneEdit';
import FxCardHeader from '../../../../Container/FxCardHeader';
import { FxTextEditSSN } from '../../../../Input/FxSSN/FxTextEditSSN';
import { FxSelectAutoSearch } from '../../../../Input/FxSelect/FxSelectAutoSearch';
import { useMediaQuery } from 'react-responsive';
import FxMaterialSelect from '../../../../Input/FxSelect/FxMaterialSelect';
import { FieldErrorMessageRender } from '../../Common/FieldErrorMessageRender';
import { useDispatch, useSelector } from 'react-redux';
import { saveNodeData, savePerFieldData } from '../../../../../libs/utils/autoSaveField';

export const JointTenancyCoOwnerAdd: React.FC<any> = React.memo(
    (props) => {
        const { register, formState: { errors }, handleSubmit, setValue, control, clearErrors, setError, watch, getValues } = useForm({mode: 'onChange',reValidateMode:'onChange'});
        const dispatch = useDispatch();
        const isSmallScreen = useMediaQuery({ query: '(max-width: 999px)' });
        const defaultTaxIdentifier = props?.data?.itin ? 'itin' : 'ssn';
        const taxIdentifier = watch('taxIdentifier') || defaultTaxIdentifier;
        const taxIdentifierData = [
            { label: "SSN", value: "ssn" },
            { label: "ITIN", value: "itin" },
        ];
        
        useEffect(() => {
            // Reset the value of the selected taxIdentifier (SSN or ITIN) field when the taxIdentifier changes
            setValue(taxIdentifier, "");

            // Clear any errors for the field that is not selected
            clearErrors(taxIdentifier === 'ssn' ? 'itin' : 'ssn');
        }, [taxIdentifier]);

        // Method handles the submit for add beneficial owner form
        function onSubmit(data: any) {
            
            //Calling the autoSave API for the below 3 nodes automatically on the time of submit
            const buildOwnerRequest = (index: number) => {
                const prefix = `owners[${index}]`;
              
                return {
                  [`${prefix}.isPrimaryOwner`]: false,
                  [`${prefix}.portalAccess.grantAccess`]: true,
                  [`${prefix}.mailingAddress[0].isPrimary`]: true,
                };
              };
              
            const autoSaveApiReq = buildOwnerRequest(props?.index);
            
            savePerFieldData(autoSaveApiReq, '/onboardingFormData');

            // If 'ssn' is being used, remove 'itin' from the data.
            // Otherwise, if 'itin' is being used, remove 'ssn' from the data
            if (taxIdentifier === 'ssn') {
                delete data.itin;
            } else {
                delete data.ssn;
            }
            delete data['taxIdentifier'];
            const req: any = { ...data, isPrimaryOwner:false,portalAccess: {
                grantAccess: true
            } };
            if (data['dob']) {
                req['dob'] = moment(data['dob']).format('MM/DD/YYYY');
            }
            req['mailingAddress'] = [{
                "addressLine1": data['addressLine1'],
                "addressLine2": data['addressLine2'],
                "city": data['city'],
                "state": data['state'],
                "zip": data['zip'],
                "isPrimary": true
            }]
            
            req['mobilePhone'] = convertToPhoneRequestFormat(req.mobilePhone)
            if(req['mobilePhone'] === ""){
                delete req['mobilePhone'];
            }
            
            const unwantedRequestArray = ['state', 'addressLine1', 'city', 'zip', 'addressLine2','mobilePhone-select'];
            deleteUnwantedRequest(req, unwantedRequestArray)
            if (props.onSubmit) {
                props.onSubmit(data, req, 'add', undefined)
            }

        }

        /**
         * Method handles the click operation for going back to joint tenancy list screen
         */
        const handleGoBackClick = () => {
            if (props?.cancel) {
                props.cancel()
            }
        }

         /**
  *  Address line 1 validation constant
  * */ 
         const setAddressLine1Validation = {
            required: true,
            minLength: {
                value: 4,
                message: AUTH_STRINGS.ERRORS.ADDRESS_LINE_1_LENGTH_VALIDATION
            },
            maxLength: {
                value: 40,
                message: AUTH_STRINGS.ERRORS.ADDRESS_LINE_1_LENGTH_VALIDATION
            }
        }

        /**
        * Error messages for Date of Birth (DOB) validation:
        * - futureDate: Error if the DOB is a future date (not allowed)
        * - maxDate: Error if the DOB indicates the user is less than 18 years old
        * - minDate: (optional) Error if the DOB is before a very old date (not needed here)
        */ 
       const dobErrorMsg={
           futureDate:AUTH_STRINGS.ERRORS.JOINT_TENANCY_SECONDARY_FUTURE,
           maxDate:AUTH_STRINGS.ERRORS.JOINT_TENANCY_SECONDARY_FUTURE,
          }

        /**
         * Method fetches data from the state
         */
        const jointOwnerState = useSelector((state: any) =>
            fetchDataFromState(state, 'customer-kyc-joint-owners-data')
        );

        /**
         * Handles auto-saving of a single form field.
         *
         * This function delegates the save logic to `saveNodeData`, passing in the current field name and value,
         * along with necessary form and state management functions like `setValue`, `getValues`, `dispatch`,
         * and the `individualState`. This ensures that field changes are persisted automatically.
         *
         * @param fieldName - The name of the field being updated.
         * @param value - The new value to be saved.
        */
        const handleAutoSave = (fieldName: string, value: any) => {
            saveNodeData('coowner-info-page', fieldName, value, setValue, getValues, dispatch, jointOwnerState, props?.index);
        }

        /**
         * Method handles the onChange Events on the DOB field
         * @param value 
         */
        const handleDOBOnChangeEvents = (value: any) => {
            handleDateValidation("dob", value, setValue, setError, clearErrors, true, moment(),null,dobErrorMsg);
            isNullOrUndefined(errors?.dob) && handleAutoSave("dob", value);
        }

        /**
         * Method handles the onChange Events on the State field
         * @param value 
         */
        const handleStateOnChangeEvents = (e: any, fieldName: string) => {
            handleFieldChange('state', e, setValue, clearErrors);
            handleAutoSave(fieldName, e);
        }
        
        return (
            <Grid container id='signUp-joint-tenancy' xs={12} className='fx-joint-tenancy-add'>
                <FxCard id="signUp-joint-tenancy-form-card" className={isSmallScreen?"fx-theme-passport fx-joint-tenancy-add-border":"fx-theme-passport"}>
                    <FxCardHeader>
                      <Typography className='fx-new-invite-owner-profile-label'>{props?.data ? props?.data?.length + 1 + ". " : 1 + ". "}Co-Owner Information</Typography>
                    </FxCardHeader>
                    <div className="fx-form-edit-profile">
                        <form id="signUp-joint-tenancy-form" onSubmit={handleSubmit(onSubmit)}>
                            <FxCardBody id="signUp-joint-tenancy-form-card-body" className="fx-info-card" >
                                <Grid container direction="row" spacing={2} className="fx-info-card-form" >
                                    <Grid item xs={12} sm={12}>
                                        <FxTextEdit register={{ ...register("firstName") }} className={errors.firstName ? "border-error-input fx-input-edit" : "fx-input-edit"} control={control} rules={{ required: true }} id="signUp-joint-tenancy-form-card-first-name" label="First Name" name="firstName" variant="outlined" 
                                        onBlur={(e) => handleAutoSave('firstName', e)}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='firstName'/>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FxTextEdit register={{ ...register("middleName") }} className={errors.lastname ? "border-error-input fx-input-edit" : "fx-input-edit"} control={control} rules={{ required: false }} id="signUp-joint-tenancy-form-card-middle-name" label="Middle Name (optional)" name="middleName" variant="outlined" 
                                        onBlur={(e) => handleAutoSave('middleName', e)}/>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FxTextEdit register={{ ...register("lastName") }} className={errors.lastname ? "border-error-input fx-input-edit" : "fx-input-edit"} control={control} rules={{ required: true }} id="signUp-joint-tenancy-form-card-last-name" label="Last Name" name="lastName" variant="outlined" 
                                        onBlur={(e) => handleAutoSave('lastName', e)}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='lastName'/>
                                    </Grid>
                                   
                                    <Grid item sm={12} xs={12}>
                                        <FxDateEdit register={{ ...register("dob") }} className={errors.dob ? "border-error-input fx-input-edit fs-mask" : "fx-input-edit fs-mask"} control={control} rules={{ required: true }} id="signUp-joint-tenancy-form-card-dob" label="Date of Birth" name="dob" variant="outlined"  maxDate={moment()}  setValue={setValue} onChange={(value) => handleDOBOnChangeEvents(value)} ageLimitMessage={dobErrorMsg.maxDate} futureDateMessage={dobErrorMsg.futureDate} />
                                        <FieldErrorMessageRender error={errors} fieldKey='dob' type='date'/>
                                    </Grid>

                                    {/*** Identification Info Fields ***/}
                                    <Grid container item xs={12} sm={12} display={'flex'} alignItems={'center'}>
                                        <Grid item>
                                            <FxLabelView id="business-owner-details-label" className="" >IDENTIFICATION INFO</FxLabelView>
                                        </Grid>
                                        <Grid item xs={1} container justifyContent="center" alignItems="center">
                                            {ShowInfoToolTip('fx-business-owner-title-tooltip', 'To keep your account secure, we need to verify some details. This helps us ensure a safe and compliant experience for you.', 'right')}
                                        </Grid>
                                    </Grid>
                                    
                                    <Grid item xs ={12} sm={12}>
                                        <FxMaterialSelect
                                            register={{ ...register("taxIdentifier") }}
                                            control={control}
                                            rules={{ required: false }}
                                            id="signUp-indivudal-form-card-tax-identifier"
                                            name="taxIdentifier"
                                            data={taxIdentifierData}
                                            value={defaultTaxIdentifier}
                                            label="Identification Method"
                                            setValue={setValue}
                                        />
                                    </Grid>
                                    <Grid container item xs={12} sm={12} display={'flex'} alignItems={'center'}>
                                        <Grid item xs={11} sm={11}>
                                            <FxTextEditSSN
                                                key={taxIdentifier}
                                                register={{ ...register(taxIdentifier) }}
                                                className={errors.ssn || errors.itin ? "border-error-input fx-input-edit" : "fx-input-edit"}
                                                error={errors?.ssn || errors?.itin}
                                                control={control}
                                                rules={taxIdentifier === 'ssn' ? { ...setSsnValidationOptions(true) } : { ...setItinValidationOptions(true) }}
                                                id="signUp-indivudal-form-card-ssn-itin"
                                                label={`${taxIdentifier === 'ssn' ? 'Social Security Number' : 'Individual Taxpayer Identification Number'}`}
                                                placeholder="XXX-XX-XXXX"
                                                name={taxIdentifier}
                                                variant="outlined"
                                                setValue={setValue}
                                                setError={setError}
                                                clearErrors={clearErrors}
                                                defaultValue={props?.data?.ssn || props?.data?.itin || ''}
                                                onBlur={(e: any) =>
                                                    handleAutoSave(taxIdentifier, e)
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={1} sm={1} container justifyContent="center" alignItems="center">
                                            {ShowInfoToolTip('fx-business-owner-title-tooltip', 'We will use tax identifier to verify your identity and will not check your credit score', 'bottom-end')}
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={isSmallScreen ? 11 : 12} sm={11} className="fx-individual-details-error-row" >
                                        <FieldErrorMessageRender error={errors} fieldKey={taxIdentifier === 'ssn' ? 'ssn' : 'itin'} />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FxLabelView id="joint-tenancy-details-label" className="" >YOUR CONTACT INFO</FxLabelView>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FxTextEdit register={{ ...register("addressLine1") }} className={errors.addressLine1 ? "border-error-input fx-input-edit fs-mask" : "fx-input-edit fs-mask"}  rules={setAddressLine1Validation} control={control} id="signUp-joint-tenancy-addressLine1" label="Address Line 1" name="addressLine1"  onChange={(e: any) => { handleAddressChange(e, setValue, setError, clearErrors) }} onBlur={(e) => handleAutoSave('addressLine1', e)} />
                                        <FieldErrorMessageRender error={errors} fieldKey='addressLine1'/>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FxTextEdit register={{ ...register("addressLine2") }} className={errors.addressLine2 ? "border-error-input fx-input-edit fs-mask" : "fx-input-edit fs-mask"} control={control} rules={{ required: false }} id="signUp-joint-tenancy-addressLine2" label="Address Line 2 (optional)" name="addressLine2" onBlur={(e) => handleAutoSave('addressLine2', e)}/>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FxTextEdit register={{ ...register("city") }} className={errors.city ? "border-error-input fx-input-edit fs-mask" : "fx-input-edit fs-mask"} control={control}  rules={setCityValidation(true)} id="signUp-joint-tenancy-city" label="City" name="city" onBlur={(e) => handleAutoSave('city', e)} />
                                        <FieldErrorMessageRender error={errors} fieldKey='city'/>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FxMaterialSelect register={{ ...register("state") }} rules={{ required: true }} className={errors.state ? "border-error-input fx-input-edit fs-mask" : "fx-input-edit fs-mask"} control={control} id="signUp-joint-tenancy-select-state" name="state" data={usa_state} label="State" setValue={setValue} value={''}  onChange={(e) => handleStateOnChangeEvents(e, 'state')}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='state'/>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FxTextEdit register={{ ...register("zip") }} className={errors.zip ? "border-error-input fx-input-edit fs-mask" : "fx-input-edit fs-mask"} control={control} rules={setZipValidationOptions(true)} id="signUp-joint-tenancy-zip" label="Zip" name="zip" onChange={(e: any) => { handleZipChange(e, setValue, setError, clearErrors) }} onKeyDown={(e: any) => { handleKeyDownChange(e, setValue) }} 
                                         onBlur={(e) => handleAutoSave('zip', e)} />
                                        <FieldErrorMessageRender error={errors} fieldKey='zip'/>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FxPhoneEdit register={register} className={errors.mobilePhone ? "border-error-input fx-input-edit" : "fx-input-edit"} control={control} rules={setPhoneValidationOptions(true)} id="signUp-joint-tenancy-form-card-mobilePhone" label="Mobile Phone" name="mobilePhone" placeholder={'XXX-XXX-XXXX'} setValue={setValue} setError={setError} clearErrors={clearErrors} isEditable={true} 
                                        onBlur={(e) => handleAutoSave('mobilePhone', e)}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='mobilePhone'/>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FxTextEdit register={{ ...register("email") }} type="email" className={errors.email ? "border-error-input fx-input-edit fs-mask" : "fx-input-edit fs-mask"} control={control} rules={setEmailValidationOptions(true)} id="signUp-joint-tenancy-form-card-email" label="Email" name="email" variant="outlined"
                                         onChange={(e: any) => { handleEmailChange(e, setValue, setError, clearErrors) }} onBlur={(e) => handleAutoSave('email', e)}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='email'/>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <Divider />
                                    </Grid>
                                </Grid>
                            </FxCardBody>
                            <FxCardFooter id="signUp-joint-tenancy-Card-Footer" className="fx-footer">
                                <Grid container direction="row" justifyContent="flex-end" className="fx-modal-footer">
                                    <FxButton
                                        disableRipple={false}
                                        variant="contained"
                                        className="fx-button fx-button-cancel"
                                        id="cancel-add-joint-tenancy-btn"
                                        onClick={handleGoBackClick}
                                    > CANCEL
                                    </FxButton>
                                    <Grid className='fx-padding-right-15'></Grid>
                                    <FxButton
                                        disableRipple={false}
                                        className="fx-button fx-button-theme"
                                        id="save-add-joint-tenancy-btn"
                                        type="submit"
                                    > Save
                                    </FxButton>
                                </Grid>
                            </FxCardFooter>
                        </form>
                    </div>
                </FxCard>
            </Grid>
        )
    }
)
